import React, { useState } from 'react';
import "./claimItemStyles.scss";
import { HandySvg } from "handy-svg";
import closeSVG from "../../Hint/HintContainer/AddImg/img/close-X.svg";
import MediaPicker from "../../../utils/js/mediaPicer/MediaPicker";
import useFileUploader from "../../../utils/js/PhotoUploader";
import ButtonHint from "../../../components/Buttons/buttonHint/ButtonHint";
import CustomAlert from "../../../components/CustomAlert/CustomAlert";
import {useSetStatIsExist} from "../../../utils/hooks/useSetStatIsExist/useSetStatIsExist";

const ClaimItem = ({ item, onUpdate }) => {

    const { setStatIsExist } = useSetStatIsExist();

    const [uploadedPhotoIds, setUploadedPhotoIds] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [updateSuccess, setUpdateSuccess] = useState(false);

    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertTitle, setAlertTitle] = useState('');

    const {
        files: uploadedPhotos,
        progress,
        statuses,
        addFiles,
        removeFile: deletePhoto,
        retryUpload,
        hasPendingUploads
    } = useFileUploader({
        compress: true,
        onUploadComplete: (fileId, serverId) => {
            setUploadedPhotoIds(prev => [...prev, serverId]);
        },
        onUploadError: (fileId, error) => {
            console.error('🟠 Ошибка загрузки файла:', { fileId, error });
        },
        onUploadRejected: async (fileId, reason) => {
            handleOpenAlert(
                'Уведомление',
                'Эту фотографию вы уже ранее загружали',
                ''
            );
            try {
                await setStatIsExist();
                console.log('✅ setStatIsExist выполнен');
            } catch (error) {
                console.error('❌ Ошибка setStatIsExist:', error);
            }
        },
    });

    const handleOpenAlert = (title, message ) => {
        setAlertTitle(title);
        setAlertMessage(message);
        setIsOpenAlert(true);
    };

    const handleCloseAlert = () => {
        setIsOpenAlert(false);
    };

    const handleCapture = (photoDataUrl) => {
        if (photoDataUrl) {
            const blob = dataURLtoBlob(photoDataUrl);
            const file = new File([blob], "camera_photo.png", { type: "image/png" });
            addFiles([file]);
        }
    };

    const dataURLtoBlob = (dataurl) => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    const handleDelete = (id) => {
        const photo = uploadedPhotos.find(p => p.id === id);
        if (!photo) return;

        if (photo.status === 'completed' && photo.serverId) {
            setUploadedPhotoIds(prev => prev.filter(pid => pid !== photo.serverId));
        }
        deletePhoto(id);
    };

    const handleSubmit = async () => {

        if (hasPendingUploads) {
            handleOpenAlert("Ошибка", "Пожалуйста, дождитесь завершения загрузки всех фотографий")
            return;
        }

        if (uploadedPhotoIds.length === 0) {
            handleOpenAlert("Ошибка", "Необходимо прикрепить хотя бы одно фото")
            return;
        }

        setIsUpdating(true);
        setUpdateSuccess(false);

        try {
            const result = await onUpdate(item.guid || item.pretensions_guid, uploadedPhotoIds);

            if (result) {
                handleOpenAlert("Успех", "Претензия успешно закрыта")

                setUpdateSuccess(true);
                setUploadedPhotoIds([]);
                uploadedPhotos.forEach(photo => {
                    deletePhoto(photo.id);
                });

                setTimeout(() => {
                    setUpdateSuccess(false);
                }, 2000);
            }
        } catch (error) {
            console.error('🔴 Ошибка в handleSubmit:', error);
            handleOpenAlert("Ошибка", `Ошибка при отправке претензии: ${(error.message || '')}`)
        } finally {
            setIsUpdating(false);
        }
    };

    const getButtonText = () => {
        if (isUpdating) return "Отправка...";
        if (updateSuccess) return "Отправлено";
        return "Закрыть претензию";
    };

    if (item.attachments_guid_array && item.attachments_guid_array.length > 0) {
        return (
            <div className="claim-item claim-item--completed">
                <div className="claim-item__info">
                    <div className="title">{item.name}</div>
                    <a href={item.url} target="_blank" className="link" rel="noopener noreferrer">
                        {item.url}
                    </a>
                </div>
                <div className="claim-item__status">✓ Обработано</div>
            </div>
        );
    }

    return (
        <div className="claim-item">
            <div className="claim-item__info">
                <div className="title">{item.name}</div>
                <a href={item.url} target="_blank" className="link" rel="noopener noreferrer">
                    {item.url}
                </a>
            </div>

            <div className="claim-item__photos">
                <div className="claim-item__photo-gallery">
                    <MediaPicker
                        onFilesSelected={addFiles}
                        onCameraCapture={handleCapture}
                    />

                    {uploadedPhotos.map(photo => {
                        const status = statuses[photo.id] || 'pending';
                        const currentProgress = progress[photo.id] || 0;

                        return (
                            <div className="img_wrapper" key={photo.id} id={photo.id}>
                                <HandySvg
                                    src={closeSVG}
                                    className="close_img"
                                    onClick={() => handleDelete(photo.id)}
                                />
                                <div
                                    className={`wrapper__file-upload addImg ${status === 'pending' ? "AwaitingDownload" : ""}`}
                                    style={{
                                        backgroundImage: `url(${photo.previewUrl})`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "cover",
                                        padding: "0",
                                    }}
                                >
                                    {status === 'pending' && (
                                        <div className="wrapper__file-upload__diteils">
                                            <div>Ожидает</div>
                                        </div>
                                    )}

                                    {status === 'uploading' && (
                                        <div className="wrapper__file-upload__diteils">
                                            <div>Загрузка {currentProgress}%</div>
                                        </div>
                                    )}

                                    {status === 'error' && (
                                        <div className="wrapper__file-upload__diteils LongLoadingTime">
                                            <div>Ошибка</div>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    retryUpload(photo.id);
                                                }}
                                                className="retry-button"
                                            >
                                                Повторить
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <ButtonHint
                text={getButtonText()}
                funck={handleSubmit}
                className={`claim-item__submit`}
            />

            {item.attachments_guid_array && item.attachments_guid_array.length > 0 && (
                <div className="claim-item__current-attachments">
                    <span>Текущие вложения: {item.attachments_guid_array.length}</span>
                </div>
            )}

            <CustomAlert
                title={alertTitle}
                message={alertMessage}
                isOpenAlert={isOpenAlert}
                onClose={handleCloseAlert}
            />

        </div>
    );
};

export default ClaimItem;